/* ---------------- Confetti helper ---------------- */
function fireConfetti () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const defaults = {
    spread: 360,
    startVelocity: 35,
    ticks: 90,
    gravity: 0.8,
    zIndex: 9999,
  };

  for (let i = 0; i < 5; i++) {
    confetti({
      ...defaults,
      particleCount: 150,
      origin: { x: Math.random(), y: Math.random() * 0.6 },
    });
  }
}

/* --------------- Celebration state --------------- */
function hasCelebrated () {
  return sessionStorage.getItem('confettiDone') === '1';
}
function markCelebrated () {
  sessionStorage.setItem('confettiDone', '1');
}
function resetCelebrationFlag () {
  sessionStorage.removeItem('confettiDone');
}

/* --------------- Page-filter helper -------------- */
function pageEligibleForConfetti () {
  const path = window.location.pathname.replace(/\/$/, ''); // quita barra final
  return !['', '/'].includes(path);                         // home = ineligible
  // Añade más rutas a ignorar si hace falta:
  // return !['', '/', '/collections/all'].includes(path);
}

/* --------------- Celebration logic --------------- */
function maybeCelebrate (cartObj) {
  const subtotal = cartObj.total_price / 100;   // Shopify da centavos
  const goal = window.freeShippingThreshold;    // 350000 por ahora

  if (subtotal >= goal) {
    if (!hasCelebrated() && pageEligibleForConfetti()) {
      fireConfetti();
      markCelebrated();
    }
  } else {
    resetCelebrationFlag(); // vuelven a quedar por debajo
  }
}

/* --------------- Listeners & initial check ------- */

// 1) Ejecutar una vez al cargar la página
fetch('/cart.js')
  .then(r => r.json())
  .then(maybeCelebrate);

// 2) Evento de Minimog cuando el drawer se actualiza
document.addEventListener('cart:updated', evt => {
  maybeCelebrate(evt.detail.cart);
});

// 3) Evento disparado tras cualquier add-to-cart AJAX
document.addEventListener('product-ajax:added', () => {
  fetch('/cart.js').then(r => r.json()).then(maybeCelebrate);
});

// 4) Algunas plantillas usan cart:refresh en su lugar
document.addEventListener('cart:refresh', () => {
  fetch('/cart.js').then(r => r.json()).then(maybeCelebrate);
});
